import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  IconButton,
  Chip,
  Tooltip,
  Box
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import GenericDialog from "../Dialog/GenericDialog";
import {
  makeDELETERequestOnUserServiceWithQueryParameter,
  makePUTRequestOnUserService,
} from "../../Api/api";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import BankDetailsInformationGrid from "./BankDetailsInformationGrid";
import documentPlaceHolderImage from "../../images/documentPlaceHolder.jpg";
import GetAppIcon from "@mui/icons-material/GetApp";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";

const toastr = require("toastr");
export default function KYCBankDetailsTab(props: any) {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedForDelete, setSelectedForDelete] = useState<string>("");
  const [showEditBankDetailsDialog, setShowEditBankDetailsDialog] =
    useState<boolean>(false);
  const [currentlySelectedForEdit, setCurrentlySelectedForEdit] =
    useState<any>(null);
  const [editMode, setEditMode] = useState<boolean>(false);
  const initialState = {
    bankName: "",
    beneficiaryName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
    kycPassword: "",
    accountType: "savings",
    nriBankAccountType: "",
    pisType: "",
    nriBankProof: null as File | null,
  };
  const [newBankDetails, setNewBankDetails] = useState(initialState);

  function getUpdatedBankDetailsObject(detail: any) {
    return {
      bankName: detail.bank_name,
      beneficiaryName: detail.beneficiary_name,
      accountNumber: detail.account_number,
      ifscCode: detail.ifsc_code,
      branchName: detail.branch_name,
      image: detail.image,
      kycPassword: detail.kyc_doc_plaintext_password,
      accountType: detail.account_type || "",
      nriBankAccountType: detail.nri_bank_account_type || "",
      pisType: detail.pis_type || "",
      nriBankProofFilename: detail.nri_bank_proof_filename || "",
      nriBankProofFile: detail.nri_bank_proof_filename_file || "",
    };
  }

  function getFileExtension(filename: string): string {
    if (!filename) return "";
    return filename.split(".").pop()?.toLowerCase() || "";
  }

  function getMimeType(filename: string): string {
    const ext = getFileExtension(filename);
    const mimeTypes: Record<string, string> = {
      pdf: "application/pdf",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
    };
    return mimeTypes[ext] || "application/octet-stream";
  }

  function downloadFile(base64Data: string, filename: string) {
    if (!base64Data || !filename) return;

    const mimeType = getMimeType(filename);
    const isPdf = mimeType === "application/pdf";

    const dataUrl = `data:${mimeType};base64,${base64Data}`;

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = filename;

    if (isPdf) {
      link.target = "_blank";
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function BankDetailList({ bankDetails }: any) {
    var details = null;
    if (
      typeof bankDetails === "object" &&
      !Array.isArray(bankDetails) &&
      bankDetails !== null
    ) {
      details = [bankDetails];
    } else {
      details = bankDetails;
    }

    const handleSetDefault = (bankDetail: any) => {
      let payload = {
        user_id: props.currentUser.uuid,
        account_number: bankDetail.account_number,
        is_default: "True",
        admin_name: JSON.parse(localStorage.getItem("loginUser")!)?.name,
      };
      makePUTRequestOnUserService(
        "/kyc/bank_detail/update_default_bank_details/",
        payload
      )
        .then((response) => {
          if (response?.status === 200) {
            toastr.success(
              "Bank details set as default! Pls close and click on eye icon again to view it set as default."
            );
          }
        })
        .catch((error) => toastr.error(error));
    };

    return (
      <Grid container spacing={2}>
        {details &&
          details.map((bankDetail: any) => {
            const isNriBankProof = !!bankDetail.nri_bank_proof;
            const isNriProofPdf =
              isNriBankProof &&
              getFileExtension(bankDetail.nri_bank_proof_filename) === "pdf";
            const isBankProofPdf =
              !!bankDetail.image &&
              getFileExtension(bankDetail.image_filename) === "pdf";

            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={bankDetail.account_number}
                sx={{ margin: 4 }}
              >
                <Card sx={{ minWidth: 275, height: "100%" }}>
                  {bankDetail.image ? (
                    isBankProofPdf ? (
                      <Box
                        sx={{
                          width: "100%",
                          height: 150,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f5f5f5",
                          borderBottom: "1px solid #e0e0e0",
                        }}
                      >
                        <PictureAsPdfIcon
                          sx={{ fontSize: 80, color: "#d32f2f" }}
                        />
                      </Box>
                    ) : (
                      <img
                        src={`data:image/png;base64, ${bankDetail.image}`}
                        alt="Bank Proof"
                        style={{
                          width: "100%",
                          maxHeight: "150px",
                          objectFit: "cover",
                        }}
                      />
                    )
                  ) : (
                    <img
                      src={documentPlaceHolderImage}
                      alt="Bank Logo"
                      style={{
                        width: "100%",
                        maxHeight: "150px",
                        objectFit: "cover",
                      }}
                    />
                  )}

                  {isNriBankProof && (
                    <Box
                      sx={{
                        padding: "8px 16px",
                        backgroundColor: "#e3f2fd",
                        borderBottom: "1px solid #bbdefb",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {isNriProofPdf ? (
                        <PictureAsPdfIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
                      ) : (
                        <DescriptionIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                      )}
                      <Typography variant="body2" color="text.secondary">
                        NRI Proof: {bankDetail.nri_bank_proof_filename || "Attached"}
                      </Typography>
                    </Box>
                  )}

                  <Typography
                    sx={{ fontSize: 14, ml: 2 }}
                    color="text.primary"
                    gutterBottom
                  >
                    Password - {bankDetail.kyc_doc_plaintext_password || "NA"}
                  </Typography>
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {bankDetail.account_number || "-"}
                    </Typography>
                    <Typography variant="h5" component="div">
                      {bankDetail.bank_name || "-"}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                      {bankDetail.beneficiary_name || "-"}
                    </Typography>
                    <Typography variant="body2">
                      {bankDetail.branch_name || "-"}
                    </Typography>
                    {bankDetail.nri_bank_account_type && (
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        NRI Type: {bankDetail.nri_bank_account_type?.toUpperCase()}
                        {bankDetail.pis_type && ` (${bankDetail.pis_type.toUpperCase()})`}
                      </Typography>
                    )}
                  </CardContent>
                  <CardActions>
                    <IconButton
                      aria-label="edit"
                      onClick={(event) => {
                        setCurrentlySelectedForEdit(
                          getUpdatedBankDetailsObject(bankDetail)
                        );
                        setEditMode(true);
                        setShowEditBankDetailsDialog(true);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      onClick={(event) => {
                        setShowDeleteModal(!showDeleteModal);
                        setSelectedForDelete(bankDetail.account_number);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>

                    {bankDetail.image && (
                      <Tooltip
                        title={`Download Bank Proof${isBankProofPdf ? " (PDF)" : ""}`}
                      >
                        <IconButton
                          aria-label="download bank proof"
                          onClick={() =>
                            downloadFile(
                              bankDetail.image,
                              bankDetail.image_filename || "bank_proof.png"
                            )
                          }
                        >
                          <GetAppIcon color={isBankProofPdf ? "error" : "primary"} />
                        </IconButton>
                      </Tooltip>
                    )}

                    {isNriBankProof && (
                      <Tooltip
                        title={`Download NRI Proof${isNriProofPdf ? " (PDF)" : ""}`}
                      >
                        <IconButton
                          aria-label="download nri bank proof"
                          onClick={() =>
                            downloadFile(
                              bankDetail.nri_bank_proof,
                              bankDetail.nri_bank_proof_filename ||
                              "nri_bank_proof.png"
                            )
                          }
                        >
                          {isNriProofPdf ? (
                            <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />
                          ) : (
                            <GetAppIcon sx={{ color: "#1976d2" }} />
                          )}
                        </IconButton>
                      </Tooltip>
                    )}

                    <Chip
                      label={
                        bankDetail.is_default ? "Default" : "Set Default"
                      }
                      color="success"
                      variant={
                        bankDetail.is_default ? "filled" : "outlined"
                      }
                      {...(!bankDetail.is_default && {
                        onClick: () => handleSetDefault(bankDetail),
                      })}
                    />
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
      </Grid>
    );
  }

  function AddBankDetailsIcon() {
    return (
      <Grid item xs="auto">
        <AddCircleIcon
          color="primary"
          fontSize="large"
          id="add-circle-id"
          onClick={(event) => {
            setShowEditBankDetailsDialog(true);
          }}
          style={{ position: "fixed", top: 120, right: 50, zIndex: 1000 }}
        />
      </Grid>
    );
  }

  function deleteBankDetails(event: any) {
    event.preventDefault();

    makeDELETERequestOnUserServiceWithQueryParameter(
      `/kyc/bank_detail/delete/${props.currentUser.uuid}/${selectedForDelete}/`
    )
      .then((response) => {
        if (response?.status === 204) {
          toastr.success("Deleted bank details !");
          setShowDeleteModal(!showDeleteModal);
          props.nullifyBankDetails(event, selectedForDelete);
        }
      })
      .catch((error) => toastr.error(error));
  }

  if (props?.bankDetails) {
    return (
      <Grid style={{ margin: "20px 0", padding: "0 20px" }}>
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs="auto">
            <AddBankDetailsIcon />
          </Grid>

          <BankDetailList bankDetails={props?.bankDetails} />
          {showDeleteModal ? (
            <GenericDialog
              show={showDeleteModal}
              heading="Delete Bank Details"
              inputProps="Are you sure you want to delete these bank details ?"
              onClose={(event: any) => {
                event.preventDefault();
                setShowDeleteModal(!showDeleteModal);
              }}
              handleSubmit={(event: any) => {
                event.preventDefault();
                deleteBankDetails(event);
              }}
            />
          ) : (
            ""
          )}
          {showEditBankDetailsDialog ? (
            <GenericDialog
              fullWidth={true}
              show={showEditBankDetailsDialog}
              heading={
                editMode ? "Update Bank Details" : "Create Bank Details"
              }
              inputProps={
                <BankDetailsInformationGrid
                  bankDetails={
                    editMode ? currentlySelectedForEdit : newBankDetails
                  }
                  saveBankDetails={props.saveBankDetails}
                  addBankDetails={props.addBankDetails}
                  accountType={props.accountType}
                  currentUser={props.currentUser}
                  nullifyBankDetails={props.nullifyBankDetails}
                />
              }
              onClose={(event: any) => {
                event.preventDefault();
                setShowEditBankDetailsDialog(!showEditBankDetailsDialog);
                if (editMode) {
                  setEditMode(false);
                }
              }}
              showSubmitButton={false}
              handleSubmit={(event: any) => {
                event.preventDefault();
                setShowEditBankDetailsDialog(!showEditBankDetailsDialog);
                if (editMode) {
                  props.saveBankDetails();
                  setEditMode(false);
                }
              }}
            />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    );
  } else {
    return (
      <>
        <Grid style={{ margin: "20px 0", padding: "0 20px" }}>
          <Grid container alignItems="center" spacing={3}>
            <AddBankDetailsIcon />
          </Grid>
        </Grid>
        {showEditBankDetailsDialog ? (
          <GenericDialog
            fullWidth={true}
            show={showEditBankDetailsDialog}
            heading={
              editMode ? "Update Bank Details" : "Create Bank Details"
            }
            inputProps={
              <BankDetailsInformationGrid
                bankDetails={
                  editMode ? currentlySelectedForEdit : newBankDetails
                }
                saveBankDetails={props.saveBankDetails}
                addBankDetails={props.addBankDetails}
                accountType={props.accountType}
                currentUser={props.currentUser}
                nullifyBankDetails={props.nullifyBankDetails}
              />
            }
            onClose={(event: any) => {
              event.preventDefault();
              setShowEditBankDetailsDialog(!showEditBankDetailsDialog);
              if (editMode) {
                setEditMode(false);
              }
            }}
            showSubmitButton={false}
            handleSubmit={(event: any) => {
              event.preventDefault();
              setShowEditBankDetailsDialog(!showEditBankDetailsDialog);
              if (editMode) {
                setEditMode(false);
              }
            }}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}